import type { SeriesUnit } from 'features/Series/api/series.types'

import { SERIES_TEXT_V2 } from '../seriesText'
import styles from './controls.module.scss'

type UnitSegmentedProps = {
  value: SeriesUnit
  onChange: (unit: SeriesUnit) => void
  ariaLabel: string
  disabled?: boolean
}

const OPTIONS: { unit: SeriesUnit; label: string }[] = [
  { unit: 'day', label: SERIES_TEXT_V2.unitDay },
  { unit: 'week', label: SERIES_TEXT_V2.unitWeek },
  { unit: 'month', label: SERIES_TEXT_V2.unitMonth },
]

export const UnitSegmented = ({
  value,
  onChange,
  ariaLabel,
  disabled = false,
}: UnitSegmentedProps) => (
  <div className={styles.segmented} role='radiogroup' aria-label={ariaLabel}>
    {OPTIONS.map(({ unit, label }) => (
      <button
        key={unit}
        type='button'
        role='radio'
        aria-checked={unit === value}
        disabled={disabled}
        className={unit === value ? `${styles.segment} ${styles.segmentOn}` : styles.segment}
        onClick={() => onChange(unit)}>
        {label}
      </button>
    ))}
  </div>
)
